var _ellipse, _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 51 48",
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.469,
    cy: 23.988,
    rx: 25,
    ry: 23.988,
    fill: "#E4E7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.871 32.287l15.469 15.38c9.274-1.393 16.854-7.584 19.838-15.94L36.832 18.313l-1.426.76-.662-.001h-1.595l-17.438.758v3.359l4.982 3.357-4.982 4.116-1.84 1.624z",
    fill: "#D4DAE1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.734,
    y: 18,
    width: 24,
    height: 6.863,
    rx: 1.529,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.668,
    y: 19.715,
    width: 20.132,
    height: 3.432,
    rx: 0.765,
    fill: "#D4DAE1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.734,
    y: 25.863,
    width: 24,
    height: 6.863,
    rx: 1.529,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.668,
    y: 27.578,
    width: 20.132,
    height: 3.432,
    rx: 0.765,
    fill: "#D4DAE1"
  })));
}
export default __webpack_public_path__ + "fonts/empty-fields-7dd778795bda9ea81692d38dbe7eda58.svg";
export { SvgEmptyFields as ReactComponent };